import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import { computed, watch, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { getVexTableProps } from '@/config';
import { getControlSalesTeamList, getProjectList } from '@/request';
export default {
  name: 'muti-supplier-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectedSupplierIds: {
      type: Array,
      default: () => []
    },
    checkType: {
      type: String,
      default: 'radio'
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    filterSupplierIds: {
      type: [String, Array],
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const store = useStore();
    store.dispatch('getDictList');
    const areaList = computed(() => store.state.dictList);
    const projectList = ref([]);

    function loadProjectList() {
      getProjectList().then(data => {
        projectList.value = Array.isArray(data) ? data : [];
      });
    }

    const table = ref();
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        form.supplierName = '';
        form.busiScop = '';
        form.projectId = '';
        loadProjectList();
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const form = reactive({
      supplierName: '',
      busiScop: '',
      projectId: ''
    });
    const defaultSelecteRowKeys = computed(() => props.selectedSupplierIds);
    const tableOptions = computed(() => {
      let type = props.viewOnly ? null : props.checkType;
      return getVexTableProps({
        columns: [...(type ? [{
          type,
          width: '50px'
        }] : []), {
          title: '团队名称',
          field: 'supplierName'
        }, {
          title: '团队类型',
          field: 'supplierCategoryName'
        }, {
          title: '团队业务区域',
          field: 'supBusiScopName'
        }, {
          title: '联系人',
          field: 'linkMan'
        }, {
          title: '联系人电话',
          field: 'linkPhone'
        }],
        proxyConfig: {
          ajax: {
            query: ({
              page
            }) => new Promise(res => {
              var _props$selectedSuppli;

              const params = {
                page: page.currentPage,
                rows: page.pageSize,
                supplierCategories: '2,3',
                supplierName: form.supplierName,
                busiScop: form.busiScop,
                projectId: form.projectId || undefined
              };
              const filterIds = props.filterSupplierIds;

              if (filterIds) {
                params.supplierIds = Array.isArray(filterIds) ? filterIds.join(',') : filterIds;
              }

              if (!props.viewOnly && (_props$selectedSuppli = props.selectedSupplierIds) !== null && _props$selectedSuppli !== void 0 && _props$selectedSuppli.length) {
                params.prioritySupplierIds = props.selectedSupplierIds.join(',');
              }

              getControlSalesTeamList(params).then(data => {
                var _props$selectedSuppli2, _props$selectedSuppli3;

                let rows = data.rows || [];

                if (!props.viewOnly && (_props$selectedSuppli2 = props.selectedSupplierIds) !== null && _props$selectedSuppli2 !== void 0 && _props$selectedSuppli2.length) {
                  const selectedIdSet = new Set(props.selectedSupplierIds.map(id => String(id)));
                  const selectedRows = [];
                  const otherRows = [];
                  rows.forEach(item => {
                    if (selectedIdSet.has(String(item.supplierId))) {
                      selectedRows.push(item);
                    } else {
                      otherRows.push(item);
                    }
                  });
                  rows = [...selectedRows, ...otherRows];
                }

                res({
                  total: data.total,
                  result: rows
                });

                if (!props.viewOnly && (_props$selectedSuppli3 = props.selectedSupplierIds) !== null && _props$selectedSuppli3 !== void 0 && _props$selectedSuppli3.length) {
                  setTimeout(() => {
                    const selectedRows = rows.filter(item => props.selectedSupplierIds.find(v => String(v) === String(item.supplierId)));

                    if (props.checkType === 'checkbox') {
                      var _table$value2;

                      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.setCheckboxRow(selectedRows, true);
                    } else if (selectedRows.length) {
                      var _table$value3;

                      (_table$value3 = table.value) === null || _table$value3 === void 0 ? void 0 : _table$value3.setRadioRow(selectedRows[0]);
                    }
                  }, 300);
                }
              });
            })
          }
        }
      });
    });

    function submit() {
      let selectRows = [];

      if (props.checkType === 'checkbox') {
        selectRows = table.value.getCheckboxRecords();
      } else {
        selectRows = [table.value.getRadioRecord()];
      }

      visible.value = false;
      emit('success', selectRows);
    }

    function resetHandle() {
      form.supplierName = undefined;
      form.busiScop = undefined;
      form.projectId = undefined;
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "控销团队信息",
        width: "80%",
        top: "5vh"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), !__props.viewOnly ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "控销团队名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.supplierName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.supplierName = $event),
              placeholder: "请输入控销团队名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "团队业务区域"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.busiScop,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.busiScop = $event),
              placeholder: "请选择",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(areaList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item.id,
                  label: item.text,
                  key: item.id
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.projectId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.projectId = $event),
              placeholder: "请选择",
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.projectId,
                  value: item.projectId,
                  label: item.projectName
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              icon: "Refresh",
              onClick: resetHandle
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};